import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const createFeatureFlag = mutator({
  schema: z.object({ id: z.string(), name: z.string() }),
  resolve: {},
  permissions: [
    {
      permission: "tenant:feature_flags_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, ctx, args: { id, name } }) => {
    const [existing] = await tx.run(
      zql.featureFlags.where("name", name).where("tenantId", ctx.tenantId)
    );
    if (existing) return;

    const now = Date.now();
    await tx.mutate.featureFlags.insert({
      id,
      name,
      createdAt: now,
      updatedAt: now,
      enabledAt: now,
      createdByUserId: ctx.userId,
      tenantId: ctx.tenantId,
    });
  },
});
